import React from 'react';
import { List } from 'antd';
import VirtualList from 'rc-virtual-list';
import dayjs from 'dayjs';

const ContainerHeight = 350;

const BOOLEAN_FIELD_LABELS = {
  verificado: 'Verificación de cuenta',
  activo: 'Estado de la cuenta',
  rechazado: 'Rechazo de cuenta',
  suspendido: 'Suspensión de cuenta',
};

const yesNo = (value) => (value === '1' || value === 1 ? 'Sí' : 'No');

const formatLogItem = (item) => {
  if (item.field === 'plan_id') {
    return {
      title: item.detail || 'Cambio de plan',
      description: `Plan ${item.old_value === '1' ? 'Gold' : 'Standard'} → ${item.new_value === '1' ? 'Gold' : 'Standard'}`,
    };
  }

  if (item.field === 'vencimiento') {
    return {
      title: `Cambio de fecha de vencimiento del plan a ${dayjs(item.new_value).format('DD/MM/YYYY')}`,
      description: item.detail ? `Anotaciones: ${item.detail}` : null,
    };
  }

  if (BOOLEAN_FIELD_LABELS[item.field]) {
    return {
      title: BOOLEAN_FIELD_LABELS[item.field],
      description: `${yesNo(item.old_value)} → ${yesNo(item.new_value)}`,
    };
  }

  return {
    title: item.detail || `Cambio de ${item.field}`,
    description: (item.old_value !== undefined && item.new_value !== undefined)
      ? `${item.old_value} → ${item.new_value}`
      : null,
  };
};

const LogList = ({ logs }) => {

  return (
    <List>
      <VirtualList
        data={(logs || []).slice().reverse()}
        height={ContainerHeight}
        itemHeight={47}
        itemKey="id"
      >
        {
          (item) => {
            const { title, description } = formatLogItem(item);
            return (
              <List.Item key={item.id}>
                <List.Item.Meta title={title} description={description} />
              </List.Item>
            );
          }
        }
      </VirtualList>
    </List>
  );
};


export default LogList;
